export default __webpack_public_path__ + "static/rsz_skalp_logo-6ce816d17c56aaf88cc7eb48bfd2a86e.png";